import { PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { ObjectTools } from "@cervval.js/common/tools";
import { CONNECTED_PS } from "@ehealth_tools/common-booking/src/permissions/permissionString";
import { BookingPages } from "../../../page.i18n";

export const agendaPages = {
    "agenda": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./agendaPage").then((module) => new module.Agenda()); },
        menuItem: {
            label: BookingPages().myAgenda,
            iconClasses: "fa-regular fa-calendar"
        },
        menus: [{
            menuUid: "bookingMenu",
            order: 2,
            sectionUid: "mainSection"
        }],
        permissions: [CONNECTED_PS]
    })
};